/**
 * Premium tiers (`utils/premium.ts`). The account's tier applies on the web
 * exactly as in the bot (parity P-3); the web sells nothing (ADR-013).
 */
import type { BotUser } from './bot/user.js';

export interface PremiumBoost {
  premium: number;
  reward: { fakecoin: number; lootcoin: number };
  mission: { fakecoin: number; lootcoin: number };
  boss: { fakecoin: number; lootcoin: number };
  roulette: number;
  bet: number;
}

/** `premiumBoost`, by tier 0–4. */
export const PREMIUM_BOOSTS: readonly PremiumBoost[] = [
  { premium: 0, reward: { fakecoin: 0, lootcoin: 0 }, mission: { fakecoin: 0, lootcoin: 0 }, boss: { fakecoin: 0, lootcoin: 0 }, roulette: 0, bet: 0 },
  { premium: 1, reward: { fakecoin: 25, lootcoin: 1 }, mission: { fakecoin: 25, lootcoin: 25 }, boss: { fakecoin: 25, lootcoin: 25 }, roulette: 1, bet: 1 },
  { premium: 2, reward: { fakecoin: 50, lootcoin: 2 }, mission: { fakecoin: 50, lootcoin: 50 }, boss: { fakecoin: 50, lootcoin: 50 }, roulette: 2, bet: 2 },
  { premium: 3, reward: { fakecoin: 100, lootcoin: 3 }, mission: { fakecoin: 100, lootcoin: 100 }, boss: { fakecoin: 100, lootcoin: 100 }, roulette: 3, bet: 3 },
  { premium: 4, reward: { fakecoin: 150, lootcoin: 4 }, mission: { fakecoin: 150, lootcoin: 150 }, boss: { fakecoin: 150, lootcoin: 150 }, roulette: 4, bet: 4 },
];

const SUMMER_2022 = { start: Date.UTC(2022, 7, 25), end: Date.UTC(2022, 9, 1) };

/**
 * `isPremium`: stored tier, +1 from 24 to 31 December (server time), +1 + bonus
 * level while a bonus period runs; capped at 4.
 */
export function premiumOf(user: Pick<BotUser, 'premium'>, now: number): PremiumBoost {
  const p0 = user.premium as BotUser['premium'] | undefined;
  if (!p0) return PREMIUM_BOOSTS[0] as PremiumBoost;
  let p = p0.level ?? 0;
  const d = new Date(now);
  if (d.getDate() >= 24 && d.getDate() <= 31 && d.getMonth() === 11) p++;
  if (now > SUMMER_2022.start && now < SUMMER_2022.end) p++;
  const end = p0.bonus?.end ?? 0;
  if (end > now) p += 1 + (p0.bonus?.level ?? 0);
  if (p > 4) p = 4;
  return PREMIUM_BOOSTS[p] as PremiumBoost;
}
